import api from '../../utils/api';

export type DoctorBlogCategoryApproval = 'pending' | 'approved' | 'rejected';

export type DoctorBlogCategory = {
  categoryId: string;
  name: string;
  createdBy: 'doctor';
  vendorId?: string | null;
  approvalStatus: DoctorBlogCategoryApproval;
  approvalReason?: string | null;
  blogCount?: number;
  addedBy?: {
    vendorId?: string | null;
    name?: string | null;
    type?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export const listDoctorBlogCategories = async (
  approvalStatus?: DoctorBlogCategoryApproval
): Promise<DoctorBlogCategory[]> => {
  const response = await api.get('/master-admin/blog-categories/doctor', {
    params: approvalStatus ? { approvalStatus } : undefined,
  });
  const categories = response.data?.categories;
  return Array.isArray(categories) ? categories : [];
};

export const approveDoctorBlogCategory = async (categoryId: string) => {
  return api.post(`/master-admin/blog-categories/${categoryId}/approve`);
};

export const rejectDoctorBlogCategory = async (
  categoryId: string,
  approvalReason?: string
) => {
  return api.post(`/master-admin/blog-categories/${categoryId}/reject`, {
    approvalReason: approvalReason?.trim() || undefined,
  });
};

export const markDoctorBlogCategoryPending = async (categoryId: string) => {
  return api.post(`/master-admin/blog-categories/${categoryId}/pending`);
};

export const deleteDoctorBlogCategory = async (categoryId: string) => {
  return api.delete(`/master-admin/blog-categories/${categoryId}`);
};
